export const MAX_REPEAT_DATES_COUNT = 10;

export const SET_SCHEDULING_TYPE = 'action/SchedulingForm/SET_SCHEDULING_TYPE';
export const SET_RECURRENCE_INTERVAL =
  'action/SchedulingForm/SET_RECURRENCE_INTERVAL';
export const SET_START_DATE = 'action/SchedulingForm/SET_START_DATE';
export const SET_START_TIME = 'action/SchedulingForm/SET_START_TIME';
export const SET_TIMEZONE = 'action/SchedulingForm/SET_TIMEZONE';
export const SET_END_DATE = 'action/SchedulingForm/SET_END_DATE';
export const SET_CUSTOM_START_DATE =
  'action/SchedulingForm/SET_CUSTOM_START_DATE';
export const SET_CUSTOM_START_TIME =
  'action/SchedulingForm/SET_CUSTOM_START_TIME';
export const ADD_CUSTOM_DATE = 'action/SchedulingForm/ADD_CUSTOM_DATE';
export const REMOVE_CUSTOM_DATE = 'action/SchedulingForm/REMOVE_CUSTOM_DATE';
export const FETCH_SCHEDULING_SUCCESS =
  'action/SchedulingForm/FETCH_SCHEDULING_SUCCESS';

export const DATE_FIELDS_ARRAY = ['startDate', 'endDate'];

export const CRON_INTERVAL_ONCE = 'once';
export const CRON_INTERVAL_DAILY = 'daily';
export const CRON_INTERVAL_WEEKLY = 'weekly';
export const CRON_INTERVAL_MONTHLY = 'monthly';
export const CRON_INTERVAL_QUARTERLY = 'quarterly';
export const CRON_CUSTOM_DATES = 'custom-dates';

export const SCHEDULING_POST_VALUES_MAP = {
  SCHEDULING_IMMEDIATE: [],
  SCHEDULING_SCHEDULED: ['startDate', 'timezone', 'interval'],
  SCHEDULING_RECURRENCE: [
    'startDate',
    'endDate',
    'timezone',
    'time',
    'interval',
  ],
  [CRON_CUSTOM_DATES]: ['startDate', 'timezone', 'time', 'interval', 'custom'],
};

export const CUSTOM_DATES_POST_KEYS = ['date', 'time'];

export const SCHEDULING_IMMEDIATE = 'SCHEDULING_IMMEDIATE';
export const SCHEDULING_RECURRENCE = 'SCHEDULING_RECURRENCE';
export const SCHEDULING_SCHEDULED = 'SCHEDULING_SCHEDULED';

export const CRON_INTERVAL_MAP = {
  [CRON_INTERVAL_DAILY]: '* * *',
  [CRON_INTERVAL_WEEKLY]: '* * #',
  [CRON_INTERVAL_MONTHLY]: '# * *',
  [CRON_INTERVAL_QUARTERLY]: '# * *', // we use the same as monthly but only keep every third month
};
